import React from 'react';
import styles from './BtnPrimary.module.scss'

const BtnPrimary = ({children, onClick, disabled}) => {
    const handleClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };

    return (
        <div className={`${styles.btnPrimary} ${disabled ? styles.disabled : ''}`} onClick={handleClick}>
            <span>{children}</span>
        </div>
    );
};

export default BtnPrimary;
